import React, { useState } from 'react';
import { useDeveloper } from '../../contexts/DeveloperContext';
import { useAuth } from '../../contexts/AuthContext';
import { DeveloperAuth } from './DeveloperAuth';

// Função para verificar se o usuário é desenvolvedor
const isDeveloper = (email: string | null | undefined): boolean => {
  return email === 'dev@playkids.com';
};

interface DeveloperRouteProps {
  children: React.ReactNode;
}

export const DeveloperRoute: React.FC<DeveloperRouteProps> = ({ children }) => {
  const { isDeveloperAuthenticated } = useDeveloper();
  const { currentUser } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(isDeveloperAuthenticated);

  const handleAuthSuccess = () => {
    setIsAuthenticated(true);
  };

  // Verificar se o usuário tem permissão de desenvolvedor
  if (!isDeveloper(currentUser?.email)) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-red-50 to-pink-50 flex items-center justify-center">
        <div className="bg-white rounded-2xl p-8 shadow-xl max-w-md w-full mx-4 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">
            Acesso Negado
          </h2>
          <p className="text-slate-600 mb-6">
            Você não tem permissão para acessar esta área. Apenas desenvolvedores autorizados podem acessar estas funcionalidades.
          </p>
          <button
            onClick={() => window.history.back()}
            className="w-full bg-slate-200 text-slate-700 px-6 py-3 rounded-lg hover:bg-slate-300 transition-colors font-medium"
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <DeveloperAuth onSuccess={handleAuthSuccess} />;
  }

  return <>{children}</>;
};
